import {Box, styled, Typography} from '@mui/material';

const BoxStyled = styled(Box)`
	border-radius: 8px;
	border: 1px solid ${({theme}) => theme.palette.grey[300]};
	background: ${({theme}) => theme.palette.grey[100]};
	padding: 8px;
	display: flex;
	align-items: center;
	gap: 8px;
	width: -webkit-fill-available;
`;

const TypographyStyled = styled(Typography)(({theme}) => ({
	color: theme.colors.gray?.['80Percent'],
}));

export {BoxStyled, TypographyStyled};
